import { Box, SxProps, Typography } from "@mui/material";

export interface NoMatchesContainerProps {
  text: string;
  sx?: SxProps;
}

const NoMatchesContainer = (props: NoMatchesContainerProps) => (
  <Box
    sx={{
      width: "100%",
      pt: 6,
      pb: 10,
      pl: 4,
      pr: 4,
      textAlign: "center",
      ...props.sx
    }}
  >
    <Typography variant="body1" color="secondary">
      {props.text}
    </Typography>
  </Box>
);

export default NoMatchesContainer;
